import { useState } from "react";
import { Folder, FileImage, Home } from "lucide-react";
import { PROJECTS, PROJECT_FILTERS } from "@/data/content";
import { SmartImg } from "@/components/primitives";

export default function WorkWindow({ onOpenProject }) {
    const [filter, setFilter] = useState("all");
    const visible = filter === "all" ? PROJECTS : PROJECTS.filter((p) => p.filter === filter);

    return (
        <div data-testid="work-window" className="flex h-full min-h-0">
            <aside className="hidden sm:flex w-44 shrink-0 flex-col border-r border-black/10 bg-black/[0.03] p-3 gap-0.5">
                <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-neutral-500 px-2 pb-2">Places</div>
                {PROJECT_FILTERS.map((f) => (
                    <button
                        key={f.key}
                        data-testid={`project-filter-${f.key}`}
                        onClick={() => setFilter(f.key)}
                        className={`flex items-center gap-2 rounded px-2 py-1.5 text-xs text-left transition-colors ${
                            filter === f.key
                                ? "bg-vermilion text-white font-semibold"
                                : "text-neutral-600 hover:bg-black/[0.06]"
                        }`}
                    >
                        {f.key === "all" ? <Home size={12} /> : <Folder size={12} />}
                        {f.label}
                    </button>
                ))}
            </aside>
            <div className="flex-1 min-w-0 flex flex-col">
                <div className="sm:hidden flex gap-1.5 overflow-x-auto p-3 border-b border-black/10">
                    {PROJECT_FILTERS.map((f) => (
                        <button
                            key={f.key}
                            data-testid={`project-filter-mobile-${f.key}`}
                            onClick={() => setFilter(f.key)}
                            className={`shrink-0 font-mono text-[10px] uppercase px-2.5 py-1 rounded-full border ${
                                filter === f.key
                                    ? "bg-vermilion border-vermilion text-white"
                                    : "border-black/20 text-neutral-600"
                            }`}
                        >
                            {f.label}
                        </button>
                    ))}
                </div>
                <div className="flex items-center justify-between px-4 py-2.5 border-b border-black/10 font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
                    <span>~/deployments — {visible.length} items</span>
                    <span>double-click to open</span>
                </div>
                <div className="flex-1 overflow-y-auto p-4 grid grid-cols-2 md:grid-cols-3 gap-4 content-start">
                    {visible.map((p) => (
                        <button
                            key={p.id}
                            data-testid={`project-card-${p.number}`}
                            onClick={() => onOpenProject(p.id)}
                            className="group flex flex-col items-center text-center rounded-lg p-2 hover:bg-black/[0.05] transition-colors"
                        >
                            <div className="relative w-full rounded-md overflow-hidden border border-black/15 bg-black/[0.03]">
                                <SmartImg
                                    src={p.image}
                                    fallback={p.fallback}
                                    alt={p.title}
                                    className="w-full aspect-[16/10] object-contain halftone"
                                />
                                <span className="absolute top-1.5 right-1.5 w-5 h-5 rounded bg-[#1a1a1a]/85 text-white flex items-center justify-center">
                                    <FileImage size={10} />
                                </span>
                            </div>
                            <span className="mt-2 text-xs font-medium leading-tight text-neutral-700 group-hover:text-vermilion transition-colors line-clamp-2">
                                {p.title}
                            </span>
                            <span className="mt-0.5 font-mono text-[9px] uppercase tracking-wider text-neutral-400">
                                plate-{p.number}.img
                            </span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
